

// // 5. Modify the TextField component to accept the 'disabled' prop
// export const TextField = ({
//   label,
//   placeholder,
//   type = "text",
//   startIcon,
//   name,
//   defaultValue,
//   disabled, // Receive the new disabled prop
// }) => (
//   <div className="space-y-1">
//     <label className="block text-xs font-medium input-lable my-3">
//       {label}
//     </label>
//     <div className="relative">
//       {startIcon && (
//         <span className="absolute inset-y-0 left-0 grid place-items-center pl-3 text-gray-400">
//           <img
//             src={startIcon}
//             alt="connet"
//             className="w-5 h-5"
//           />        </span>
//       )}
//       <input
//         type={type}
//         name={name}
//         defaultValue={defaultValue}
//         placeholder={placeholder}
//         disabled={disabled} // Apply the disabled attribute to the input
//         className={[
//           "w-full h-11 rounded-[13px] border bg-white text-gray-800 placeholder:text-gray-400 ",
//           "px-4 py-3 outline-none transition",
//           "focus:border-violet-500 focus:ring-4 focus:ring-violet-500/10",
//           "border-[#E6E2FF] shadow-[inset_0_0_0_1px_rgba(108,69,255,0.15)]",
//           disabled ? "bg-gray-100 cursor-not-allowed opacity-70" : "", // Optional: Add styles for disabled state
//           startIcon ? "pl-10" : "",
//         ].join(" ")}
//       />
//     </div>
//   </div>
// );

// import React, { useState } from "react";

// export const TextField = ({
//   label,
//   required,      // ✅ add this
//   placeholder,
//   type = "text",
//   startIcon,
//   name,
//   rightIcon,      // optional custom right icon
//   defaultValue,
//   disabled,
//   inputclassName,
//   value,          // ✅ add this
//   onChange,       // ✅ add this
//   error,          // ✅ show validation error
//   // select helpers
//   select,         // render a <select> instead of input
//   selectType,     // 'year' to auto-generate years
//   options,        // array of { value, label }
//   startYear = 1950,
// }) => {
//   const [showPassword, setShowPassword] = useState(false);

//   const isPasswordField = type === "password";
//   const inputType = isPasswordField && showPassword ? "text" : type;

//   return (
//     <div className={`space-y-1 ${inputclassName}`}>
//       {label && (
//         <label className="block text-xs font-medium input-lable my-3">
//           {label}
//         </label>
//       )}

//       <div className="relative">
//         {startIcon && (
//           <span className="absolute inset-y-0 left-0 grid place-items-center pl-3 text-gray-400">
//             <img src={startIcon} alt="" className="w-5 h-5" />
//           </span>
//         )}

//         {/* Render select when requested */}
//         {select ? (
//           <select
//             name={name}
//             value={value}
//             onChange={onChange}
//             disabled={disabled}
//             required={required}
//             className={[
//               "w-full h-11 rounded-[13px] bg-white text-gray-800 placeholder:text-gray-400",
//               "px-4 py-3 outline-none transition",
//               error
//                 ? "border-red-500 focus:border-red-500 focus:ring-4 focus:ring-red-100"
//                 : "border-[#E6E2FF] focus:border-violet-500 focus:ring-4 focus:ring-violet-500/10",
//               "shadow-[inset_0_0_0_1px_rgba(108,69,255,0.15)]",
//               disabled ? "bg-gray-100 cursor-not-allowed opacity-70" : "",
//               startIcon ? "pl-10" : "",
//             ].join(" ")}
//           >
//             <option value="">Select</option>
//             {options && options.length > 0
//               ? options.map((opt) => (
//                 <option key={opt.value ?? opt} value={opt.value ?? opt}>
//                   {opt.label ?? opt}
//                 </option>
//               ))
//               : selectType === "year"
//                 ? Array.from({ length: new Date().getFullYear() - startYear + 1 }, (_, i) => startYear + i).map((yr) => (
//                   <option key={yr} value={String(yr)}>
//                     {yr}
//                   </option>
//                 ))
//                 : null}
//           </select>
//         ) : (
//           <>
//             <input
//               type={inputType}
//               name={name}
//               value={value}             // ← controlled input
//               onChange={onChange}       // ← pass event up
//               placeholder={placeholder}
//               disabled={disabled}
//               defaultValue={defaultValue}
//               required={required}       // ✅ add required attribute
//               className={[
//                 "w-full h-11 rounded-[13px] bg-white text-gray-800 placeholder:text-gray-400",
//                 "px-4 py-3 outline-none transition",
//                 error
//                   ? "border-red-500 focus:border-red-500 focus:ring-4 focus:ring-red-100"
//                   : "border-[#E6E2FF] focus:border-violet-500 focus:ring-4 focus:ring-violet-500/10",
//                 "shadow-[inset_0_0_0_1px_rgba(108,69,255,0.15)]",
//                 disabled ? "bg-gray-100 cursor-not-allowed opacity-70" : "",
//                 startIcon ? "pl-10" : "",
//                 (isPasswordField || rightIcon) ? "pr-10" : "",
//               ].join(" ")}
//             />

//             {(isPasswordField || rightIcon) && (
//               <div className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
//                 {isPasswordField ? (
//                   <button
//                     type="button"
//                     onClick={() => setShowPassword((prev) => !prev)}
//                     className="focus:outline-none mt-2"
//                   >
//                     {showPassword ? (
//                       <img src={"./input-logos/eye.svg"} alt="" className="w-5 h-5" />
//                     ) : (
//                       <img src={"./input-logos/eye.svg"} alt="" className="w-5 h-5" />
//                     )}
//                   </button>
//                 ) : (
//                   <img src={rightIcon} alt="" className="w-5 h-5" />
//                 )}
//               </div>
//             )}
//           </>
//         )}
//       </div>
//       {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
//     </div>
//   );
// };



import React, { useState } from "react";
import { useRef, useEffect } from "react";

export default function CustomSelect ({
  value,
  onChange,
  options = [],
  placeholder = "Select"
}) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // close dropdown click outside
  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div className="relative w-full" ref={dropdownRef}>
      {/* MAIN BOX */}
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="
          w-full h-11 rounded-[13px] bg-white text-gray-800
          px-4 flex items-center justify-between
          border border-[#E6E2FF]
          shadow-[inset_0_0_0_1px_rgba(108,69,255,0.15)]
          focus:border-violet-500 focus:ring-4 focus:ring-violet-500/10
        "
      >
        <span>{value?.label || placeholder}</span>
        <img src="./input-logos/dark-arrow.svg" className="w-4 h-4 opacity-60" />
      </button>

      {/* DROPDOWN MENU */}
      {open && (
        <div
          className="
            absolute mt-1 w-full bg-white rounded-xl shadow-xl z-50 
            max-h-60 overflow-y-auto border border-gray-200
          "
        >
          {options.map((opt) => (
            <div
              key={opt.value}
              onClick={() => {
                onChange(opt);
                setOpen(false);
              }}
              className="
                px-4 py-2 cursor-pointer text-gray-700 text-sm 
                hover:bg-violet-100
              "
            >
              {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export const TextField = ({
  label,
  required,
  placeholder,
  type = "text",
  startIcon,
  name,
  rightIcon,
  defaultValue,
  disabled,
  inputclassName,
  value,
  onChange,
  error,
  select,
  selectType,
  options,
  startYear = 1950,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPasswordField = type === "password";
  const inputType = isPasswordField && showPassword ? "text" : type;

  return (
    <div className={`space-y-1 ${inputclassName}`}>
      {label && (
        <label className="block text-xs font-medium input-lable my-3">
          {label}
        </label>
      )}

      <div className="relative">
        {startIcon && (
          <span className="absolute inset-y-0 left-0 grid place-items-center pl-3 text-gray-400">
            <img src={startIcon} alt="" className="w-5 h-5" />
          </span>
        )}

        {/* ---------- SELECT FIELD ---------- */}
        {select ? (
          <CustomSelect
            value={options?.find((o) => o.value === value)}
            onChange={(opt) =>
              onChange({ target: { name, value: opt.value } })
            }
            options={options}
            placeholder="Select"
          />
        ) : (
          <>
            {/* ---------- INPUT FIELD ---------- */}
            <input
              type={inputType}
              name={name}
              value={value}
              onChange={onChange}
              placeholder={placeholder}
              disabled={disabled}
              defaultValue={defaultValue}
              required={required}
              {...rest}
              className={[
                "w-full h-11 rounded-[13px] bg-white text-gray-800 placeholder:text-gray-400",
                "px-4 py-3 outline-none transition",
                error
                  ? "border-red-500 focus:border-red-500 focus:ring-4 focus:ring-red-100"
                  : "border-[#E6E2FF] focus:border-violet-500 focus:ring-4 focus:ring-violet-500/10",
                "shadow-[inset_0_0_0_1px_rgba(108,69,255,0.15)]",
                disabled ? "bg-gray-100 cursor-not-allowed opacity-70" : "",
                startIcon ? "pl-10" : "",
                (isPasswordField || rightIcon) ? "pr-10" : "",
              ].join(" ")}
            />

            {(isPasswordField || rightIcon) && (
              <div className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
                {isPasswordField ? (
                  <button
                    type="button"
                    onClick={() => setShowPassword((prev) => !prev)}
                    className="focus:outline-none mt-2"
                  >
                    <img
                      src={"./input-logos/eye.svg"}
                      alt=""
                      className="w-5 h-5"
                    />
                  </button>
                ) : (
                  <img src={rightIcon} alt="" className="w-5 h-5" />
                )}
              </div>
            )}
          </>
        )}
      </div>

      {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
    </div>
  );
};

